
import Clarity from '@microsoft/clarity';
import { useEffect, useState } from "react";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import EditorPageLayout from "../../common/editor/EditorPageLayout";
import Form from "./form/Form";

export default function WorkshopAdd() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop, setIsDesktop] = useState(() => window.innerWidth > 768);

	useEffect(() => {
		const onResize = () => setIsDesktop(window.innerWidth > 768);
		window.addEventListener("resize", onResize);
		return () => window.removeEventListener("resize", onResize);
	}, []);

	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'کارگاه‌ها', href: '/workshop_list/' },
		{ label: 'افزودن کارگاه' },
	];

	return (
		<EditorPageLayout
			isDesktop={isDesktop}
			pageTitle="افزودن کارگاه"
			metaDescription="ساخت کارگاه جدید در همراهتیم"
			breadcrumbLinks={linkDataList}
		>
			<Form isDesktop={isDesktop} />
		</EditorPageLayout>
	);
}
